export default {"src":"/_next/static/media/code-sandbox.b7eb141a.svg","height":26,"width":180};